$(function(){
    var jcropApi;
});

$(document).on('click',"#takePictureBtn",function(){
    $("#userImageInput").attr('capture','user');
    $("#userImageInput").click();
});
$(document).on('click',"#selectImageBtn",function(){
    $("#userImageInput").removeAttr('capture');
    $("#userImageInput").click();
});

var maxW=800;
var maxH=600;
$(document).on('click','#saveImage',function(){

    var input = $('#userImageInput')[0];
    var file = input && input.files && input.files[0];
    if (!file) return;

    var dataurl = null;

    // Create an image
    var img = document.createElement("img");
    // Create a file reader
    var reader = new FileReader();
    // Set the image once loaded into file reader
    reader.onload = function(e)
    {
        img.src = e.target.result;

        img.onload = function () {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = maxW;
            var MAX_HEIGHT = maxH;
            var width = img.width;
            var height = img.height;

            var scale = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
            width *= scale;
            height *= scale;
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            dataurl = canvas.toDataURL("image/png");
            var blobBin = atob(dataurl.split(',')[1]);
            var array = [];
            for(var i = 0; i < blobBin.length; i++) {
                array.push(blobBin.charCodeAt(i));
            }
            var nom = (new Date()).toISOString().replace(/[^0-9]/g, "") + ".png";
            var file_uppload = new Blob([new Uint8Array(array)], {type: 'image/png', name: nom});
            // En teoria mai passarà ja que la transformem
            if (file_uppload.size > 2097152) { // 2Mb
                process_response({
                    status: 'ok',
                    data: {
                        msg: Lang.get('msg.MaxSizeFoto')
                    }
                }, false, $("#userImageInputResponse"));

                $("#PhotoPreview").empty();
                $("#saveImage").addClass('hidden');
            }
            else {
                $.ajax({
                    type: 'POST',
                    url: '/api/socio/changeImageUser',
                    data: JSON.stringify({
                        pictureBase64: dataurl.split(',')[1],
                        cropx: $("#cropx").val(),
                        cropy: $("#cropy").val(),
                        cropw: $("#cropw").val(),
                        croph: $("#croph").val()
                    }),
                    headers: {'X-CSRF-Token': $('meta[name=csrf_token]').attr('content')},
                    cache: false,
                    contentType: 'application/json; charset=UTF-8',
                    dataType: 'json',
                    processData: false,
                    success: function (data) {
                        process_response({
                            status: 'ok',
                            data: {
                                msg: Lang.get('msg.CambiosRealizadosCorrectamente')
                            }
                        }, false, $("#userImageInputResponse"));
                        $("#userImagePreview").attr('src',data.res.src);
                        $(".thumbnail.user-photo img").attr('src',data.res.src);
                        $("#PhotoPreview").empty();
                        $("#saveImage").addClass('hidden');

                    },
                    error: function (data) {
                        alert((data.responseJSON && data.responseJSON.message) || 'No se ha podido guardar la imagen.');
                    }
                });
            }
        } // img.onload
    }
    reader.onerror = function() { alert('No se ha podido leer la imagen.'); };
    img.onerror = function() { alert('El archivo no es una imagen válida.'); };
    // Load files into file reader
    reader.readAsDataURL(file);

});


function displayAsImage(imgMin) {

/*    var imgURL = URL.createObjectURL(file),

    img.onload = function() {
        URL.revokeObjectURL(imgURL);
    }; */
    var img = document.createElement('img');
    img.src = imgMin;

    $(img).addClass('img-responsive');
    $(img).width('200px');
    $("#PhotoPreview").empty();
    $("#PhotoPreview").html(img);

    var boxwidth = 600;
    if($('#PhotoPreview').width()<boxwidth)
        boxwidth = $('#PhotoPreview').width();

    function showCoords(c)
    {
        // variables can be accessed here as
        // c.x, c.y, c.x2, c.y2, c.w, c.h
        $("#cropx").val(c.x);
        $("#cropy").val(c.y);
        $("#cropw").val(c.w);
        $("#croph").val(c.h);
    };

    $('#PhotoPreview img').Jcrop({
        aspectRatio: 1,
        boxWidth: boxwidth,
        onSelect:    showCoords,
        onChange: showCoords,
        setSelect: [ 175, 100, 800, 600 ],
    },function(){
        var jcropApi = this;
    });

}

$(function(){

    var input = document.getElementById('userImageInput');
    if (typeof input!=='undefined' && input!==null) {
        input.onchange = function () {
            var file = input.files[0];
            if (!file) return;

            //Controlamos tamaño imagen
            var size = file.size / 1024 / 1024;

            if (size > 10) {
                alert(Lang.get('msg.ImagenDemasiadoGrande'));
                return;
            }

                var img = new Image();
                img.onload = function() {

                    var canvas=document.createElement("canvas");
                    var ctx=canvas.getContext("2d");
                    var iw=img.width;
                    var ih=img.height;
                    var scale=Math.min((maxW/iw),(maxH/ih));
                    var iwScaled=iw*scale;
                    var ihScaled=ih*scale;
                    canvas.width=iwScaled;
                    canvas.height=ihScaled;
                    ctx.drawImage(img,0,0,iwScaled,ihScaled);

                    $("#saveImage").removeClass('hidden');
                    $("#useAnotherImage").removeClass('hidden');
                    $("#selectImageBtn").addClass('hidden');
                    $("#takePictureBtn").addClass('hidden');

                    displayAsImage(canvas.toDataURL());

                    //displayAsImage(file); // see Example 7

                };
                img.src = URL.createObjectURL(input.files[0]);
        };
    }

    if(window.location.hash=='#collapse2Panel') {
        $("#collapse2").collapse('show');
    }
});

function useAnotherImageReloadPage(){
    if(window.location.hash!=='#collapse2Panel') {
        window.location.href += '#collapse2Panel';
    }
    location.reload();
}

function rankingreservaplayActualizaDatosCallback(data){
    if(data.status=='ok'){
        $(".formRankingReservaplayActivarUsuario").removeClass('hidden');
        $("#rankingReservaplayPedirDatosUsuarioForm #rankingReservaplayPedirDatosUsuarioFormPedirNif").remove();
        $("#rankingReservaplayPedirDatosUsuarioForm #rankingReservaplayPedirDatosUsuarioFormPedirGenero").remove();
        $("#rankingReservaplayPedirDatosUsuarioForm #rankingReservaplayPedirDatosUsuarioFormActualizarBtn").remove();
    }
}

var movimientosTable = 0;
function cargaMovimientos(){
    $.fn.dataTable.moment( 'DD/MM/YYYY H:m');
    var start_date = $("#usermanager_movimientos_panel [name=start_date]").val();
    var end_date = $("#usermanager_movimientos_panel [name=end_date]").val();
    var url = '/api/user_manager/movimientosTable?start_date='+start_date+'&end_date='+end_date;
    if (movimientosTable==0){
        movimientosTable = $('#movimientosTable').DataTable({
            "ajax": url,
            language: {
                url: '/vendor/datatables-i18n/i18n/'+lang+'.json'
            },
            "columnDefs": [
                { "width": "80px", "targets": 0 }
            ],
            "order": [[ 0, "desc" ]],
            dom: 'Bfrtip',
            buttons: [
                {
                    extend: 'excelHtml5',
                    text: 'Excel',
                    title: 'Moviments'
                }
            ]
        });
    }else{
        movimientosTable.ajax.url( url ).load();
    }
    $('#usermanager_movimientos_panel #refrescar').addClass('btn-default');
    $('#usermanager_movimientos_panel #refrescar').removeClass('btn-success');
}

var tarjetasTable = 0;

function cargaTarjetasTable() {
    if (tarjetasTable === 0) {
        tarjetasTable = $('#tarjetasTable').DataTable({
            ajax: '/api/user_manager/obtener_tarjetas_usuario',
            rowId: 'id', 
            language: {
                url: '/vendor/datatables-i18n/i18n/' + lang + '.json'
            },
            columns: [
                {
                    data: 'numero_tarjeta'
                },
                {
                    data: 'fecha_expiracion',
                    render: function (data) {
                        return data ? moment(data).format('DD-MM-YYYY') : '-';
                    }
                },
                {
                    data: 'nombre_tarjeta',
                    render: function (data) {
                        return data ? data : '-';
                    }
                },
                {
                    data: 'asignada_pago_cuotas',
                    orderable: false,
                    searchable: false,
                    className: 'text-center',
                    render: function (data, type, row) {
                        return ''
                            + '<input type="checkbox"'
                            + ' class="tarjeta-cuotas"'
                            + ' data-id="' + row.id + '"'
                            + (data == 1 ? ' checked' : '')
                            + '>'
                            + ' ' + Lang.get('msg.PAGAMENT_PER_QUOTES');
                        }
                },
                {
                    data: null,
                    orderable: false,
                    searchable: false,
                    render: function (data, type, row) {
                        return ''
                            + '<button class="btn btn-success btn-sm" onclick="editarTarjeta(' + row.id + ')">'
                            + Lang.get('msg.edit')
                            + '</button>'
                            + ' '
                            + '<button class="btn btn-danger btn-sm" onclick="eliminarTarjeta(' + row.id + ')">'
                            + Lang.get('msg.delete')
                            + '</button>';
                    }
                }
            ],
            order: [[0, 'asc']]
        });
    } else {
        tarjetasTable.ajax.reload(null, false);
    }
}

var cuotasProgramadasTable = 0;
function cargaCuotasProgramadas() {
    $.fn.dataTable.moment('DD/MM/YYYY');
    var start_date = $("#cuotas_programadas_panel [name=start_date]").val();
    var end_date   = $("#cuotas_programadas_panel [name=end_date]").val();

    var url = '/api/user_manager/obtener_cuotas_programadas'
        + '?start_date=' + start_date
        + '&end_date=' + end_date;

    if (cuotasProgramadasTable === 0) {
        cuotasProgramadasTable = $('#cuotasProgramadasTable').DataTable({
            ajax: url,
            language: {
                url: '/vendor/datatables-i18n/i18n/' + lang + '.json'
            },
            columns: [
                { data: 'fecha_proxima' },
                { data: 'desc_cuota' },
                { data: 'precio',
                    render: function (data, type, row) {
                        if (data === null || data === undefined) {
                            return '0,00';
                        }
                        return parseFloat(data)
                            .toFixed(2)
                            .replace('.', ',');
                    }
                 }
            ],
            order: [[0, "asc"]],
            dom: 'Bfrtip',
            buttons: [
                {
                    extend: 'excelHtml5',
                    text: 'Excel',
                    title: 'Quotes_Programades'
                }
            ]
        });

    } else {
        cuotasProgramadasTable.ajax.url(url).load();
    }

    $('#cuotasProgramadasTable #refrescar')
        .removeClass('btn-success')
        .addClass('btn-default');
}

$(document).on('change', '.tarjeta-cuotas', function () {

    var tarjetaId = $(this).data('id');

    $.post('/api/user_manager/asignar_tarjeta_pago_cuotas', {
        tarjeta_id: tarjetaId
    }, function () {
        tarjetasTable.ajax.reload(null, false);
    });

});

function editarTarjeta(tarjetaId) {
    var rowData = tarjetasTable.row('#' + tarjetaId).data();
    $('#tarjeta_id').val(tarjetaId);
    $('#tarjeta_alias').val(rowData.nombre_tarjeta);
    $('#tarjeta_caducidad').val(rowData.fecha_expiracion);
    $('#editarTarjetaModal').modal('show');
}

function guardarTarjeta() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    var tarjetaId = $('#tarjeta_id').val();
    var alias = $('#tarjeta_alias').val();

    $.ajax({
        url: '/api/socioTarjeta/' + tarjetaId,
        type: 'PUT',
        data: {
            tarjeta: {
                nombre_tarjeta: alias
            }
        },
        success: function (response) {

            if (response.status === 1) {
                $('#editarTarjetaModal').modal('hide');
                tarjetasTable.ajax.reload(null, false);
            }
        },
    });
}

var tarjetaAEliminar = null;

function eliminarTarjeta(tarjetaId) {
    var checkbox = $('.tarjeta-cuotas[data-id="' + tarjetaId + '"]');

    if (checkbox.length && checkbox.is(':checked')) {
        $('#tarjetasAlert')
            .text(Lang.get('msg.NO_SE_PUEDE_ELIMINAR_SELECIONADA_CUOTA'))
            .fadeIn();

        setTimeout(function () {
            $('#tarjetasAlert').fadeOut();
        }, 4000);
        return;
    }

    tarjetaAEliminar = tarjetaId;

    $('#confirmDeleteModal').modal('show');
}

function nuevaTarjeta() {
    window.location.href = '/socioTarjeta/guardar_nueva_tarjeta';
}


$('a[href="#tab-metodes-pagament"]').on('shown.bs.tab', function () {
    cargaTarjetasTable();
});

$('a[href="#tab-quotes-programades"]').on('shown.bs.tab', function () {
    var panel = $('#cuotas_programadas_panel');
    var inicio = panel.find('[name=start_date]');
    var fin   = panel.find('[name=end_date]');

    if (!inicio.val()) {
        inicio.val(moment().format('DD/MM/YYYY'));
    }

    if (!fin.val()) {
        fin.val(moment().add(3, 'months').format('DD/MM/YYYY'));
    }

    cargaCuotasProgramadas();
});

function confirmarEliminarTarjeta() {

    if (!tarjetaAEliminar) return;

    $.ajax({
        url: '/api/socioTarjeta/' + tarjetaAEliminar,
        type: 'DELETE',
        success: function (response) {
            if (response.status === 1) {
                tarjetasTable.ajax.reload(null, false);
            }
        },
    });

    $('#confirmDeleteModal').modal('hide');
    tarjetaAEliminar = null;
}


$(document).on('shown.bs.tab', 'a[href="#tab-movimientos"]', function () {
    cargaMovimientos();
});
$(document).on('click','#usermanager_movimientos_panel #refrescar',function () {
    cargaMovimientos();
});
$(document).on('change','#usermanager_movimientos_panel [name=start_date]',function () {
    $('#usermanager_movimientos_panel #refrescar').addClass('btn-success');
});
$(document).on('change','#usermanager_movimientos_panel [name=end_date]',function () {
    $('#usermanager_movimientos_panel #refrescar').addClass('btn-success');
});

$(document).on('click','#usermanager_documentos_panel #collapse_documentos_btn',function () {
    cargar_documentos();
});

var documentos_table = 0;
function cargar_documentos(){

    var url = '/api/user_manager/documentos';

    if (documentos_table==0){
        documentos_table = $('#documentos_table').DataTable({
            "ajax": url,
            language: {
                url: '/vendor/datatables-i18n/i18n/'+lang+'.json'
            },
            "columns": [
                { "data": "descripcion" },
                { "data": "url" }
            ],
            "order": [[ 0, "asc" ]]
        });
    } else documentos_table.ajax.url(url).load();
}

function imprimirDirectoFS(tipo_servidor) {
    var sStyle = '<style>@page { size: auto;  margin: 4mm; }</style>';
    if(tipo_servidor == 'aws_pre'){
        var printDivCSS = new String (sStyle +
            '<link href="https://statics-pre.reservaplay.com/css/default.css" rel="stylesheet" type="text/css">' +
            '<link href="https://statics-pre.reservaplay.com/css/admin.css" rel="stylesheet" type="text/css">' +
            '<link href="https://statics-pre.reservaplay.com/css/main.css" rel="stylesheet" type="text/css">' +
            '<link href="https://statics-pre.reservaplay.com/css/user.css" rel="stylesheet" type="text/css">' +
            '<div>');
    }
    else if(tipo_servidor == 'aws'){
        var printDivCSS = new String (sStyle +
            '<link href="https://statics.reservaplay.com/css/default.css" rel="stylesheet" type="text/css">' +
            '<link href="https://statics.reservaplay.com/css/admin.css" rel="stylesheet" type="text/css">' +
            '<link href="https://statics.reservaplay.com/css/main.css" rel="stylesheet" type="text/css">' +
            '<link href="https://statics.reservaplay.com/css/user.css" rel="stylesheet" type="text/css">' +
            '<div>');
    }
    else{
        var printDivCSS = new String (sStyle +
            '<link href="/css/default.css" rel="stylesheet" type="text/css">' +
            '<link href="/css/admin.css" rel="stylesheet" type="text/css">' +
            '<link href="/css/main.css" rel="stylesheet" type="text/css">' +
            '<link href="/css/user.css" rel="stylesheet" type="text/css">' +
            '<div>');
    }
console.log("imprimir directo");
    var QRHtml = document.getElementById("imprimirFacturaSimplificada");
    var finalHtml = "</div>";
    var WinPrint = window.open('', '', 'left=auto,top=auto,width=auto,height=auto,toolbar=0,scrollbars=0,status=0');
    WinPrint.document.write(printDivCSS + QRHtml.innerHTML + finalHtml);
    WinPrint.document.close();
    WinPrint.focus();
    setTimeout(function(){
        WinPrint.print();
        WinPrint.close();
    }, 2000);
}

function facturaUsuarioExportPdf(e){
    var divFacturaSimplificada = $('#imprimirFacturaSimplificada');
    var pdfNombre = $(e).data('pdf_nombre');
    var containerWrap = $('<div class="pdfContainer full-container" style="font-size: 0.8em;"/>');
    containerWrap.append($(divFacturaSimplificada).html());
    containerWrap.find('.pdf_remove').remove();
    containerWrap.css({ width:300});
    $('body').append(containerWrap);
    kendoDomtoDrawing(containerWrap,pdfNombre);
}

